const INACTIVE_DEVICE_STATUS_RE = /неактив|вимк|обслугов|disabled|inactive|offline/i;

const normalizeId = (value) => {
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : null;
};

const normalizeText = (value) => (typeof value === "string" ? value.trim() : "");

export const buildDoorLabel = (location) => {
    const locationName = normalizeText(location?.location_name);
    const streetHouse = [normalizeText(location?.street), normalizeText(location?.house_number)]
        .filter(Boolean)
        .join(" ");

    if (locationName && streetHouse) return `${locationName}, ${streetHouse}`;
    return locationName || streetHouse || "";
};

const isDeviceActiveForDoor = (device) => {
    const statusName = normalizeText(device?.status_name);
    if (!statusName) return true;
    return !INACTIVE_DEVICE_STATUS_RE.test(statusName);
};

export const buildDoorEntries = ({ devices, locations, sockets }) => {
    const activeSocketIds = new Set(
        (Array.isArray(sockets) ? sockets : [])
            .map((socket) => normalizeId(socket?.id))
            .filter((socketId) => socketId !== null)
    );

    const locationMap = new Map(
        (Array.isArray(locations) ? locations : []).map((location) => [normalizeId(location?.id), location])
    );

    const socketMetaMap = new Map(
        (Array.isArray(sockets) ? sockets : []).map((socket) => [normalizeId(socket?.id), socket])
    );

    const entriesBySocketId = new Map();

    for (const device of Array.isArray(devices) ? devices : []) {
        const socketId = normalizeId(device?.socket_id);
        if (socketId === null || !activeSocketIds.has(socketId)) continue;
        if (!isDeviceActiveForDoor(device)) continue;

        const locationId = normalizeId(device?.location_id);
        const location = locationMap.get(locationId) || null;
        const socketMeta = socketMetaMap.get(socketId) || null;
        const locationLabel = buildDoorLabel(location);
        const deviceName = normalizeText(device?.device_name);
        const descriptions = normalizeText(device?.descriptions) || normalizeText(socketMeta?.descriptions);

        entriesBySocketId.set(socketId, {
            id: socketId,
            socket_id: socketId,
            location_id: locationId,
            device_name: deviceName || normalizeText(socketMeta?.name) || `Підʼїзд #${socketId}`,
            descriptions,
            location_name: normalizeText(location?.location_name) || normalizeText(device?.location_name),
            label: locationLabel || deviceName || normalizeText(socketMeta?.name) || `Підʼїзд #${socketId}`,
        });
    }

    return Array.from(entriesBySocketId.values()).sort((left, right) =>
        left.label.localeCompare(right.label, "uk-UA", { numeric: true, sensitivity: "base" })
    );
};